import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController} from '@ionic/angular';
import { TrophyComponent } from '../../../components/trophy/trophy';
import { LoaderProvider } from '../../../providers/loader/loader';
import { ResultListModel, ResultProvider, TrophyColor, TrophyMaterial, TrophyType } from '../../../providers/result/result';
import { Router } from '@angular/router';
import { NavStateService } from 'src/providers/nav-state/nav-state.service';

/**
 * Generated class for the ResultEditTrophyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-edit-trophy',
  templateUrl: 'result-edit-trophy.html',
  styleUrls:['./result-edit-trophy.scss']
})
export class ResultEditTrophyPage {

  @ViewChild("trophy")
  trophyComponent: TrophyComponent;

  resultBackup: ResultListModel;

  types: TrophyType[] = [];
  selectedType: TrophyType;

  colors: TrophyColor[] = [];
  selectedColor: TrophyColor;

  materials: TrophyMaterial[];
  selectedMaterial: TrophyMaterial;

  result: ResultListModel;
  anotherType = false;
  hideOthers = false;
  constructor(
    public navCtrl: NavController,
    public router:Router,
    private resultService: ResultProvider,
    public translate: TranslateService,
    private loadingCtrl: LoadingController,
    private navStateService:NavStateService
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    this.types = state['data'].types;
    this.colors = state['data'].colors;
    this.materials = state['data'].materials;

    this.resultBackup = state['data'].result;

    this.result = JSON.parse(JSON.stringify(state['data'].result));

    // this.result.hasDatum = !this.result.hasDatum;
    // this.result.hasPlatz = !this.result.hasPlatz;
    // this.result.hasStrecke = !this.result.hasStrecke;
    // this.result.hasZeit = !this.result.hasZeit;

    this.selectedType = this.types.find(x => x.modelName === this.result.trophyType);
    this.selectedColor = this.colors.find(x => x.id === parseInt(this.result.trophyColor));
    this.selectedMaterial = this.materials.find(x => x.id === parseInt(this.result.trophyMaterial));
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter ResultEditTrophyPage');
  }

  selectType(type: TrophyType) {
    this.selectedType = type;
    this.result.trophyType = this.selectedType.modelName;
    this.updateTrophy();
  }

  selectColor(color: TrophyColor) {
    this.selectedColor = color;
    this.result.trophyColor = color.id + "";
    this.updateTrophy();
  }

  selectMaterial(material: TrophyMaterial) {
    this.selectedMaterial = material;
    this.result.trophyMaterial = material.id + "";
    this.updateTrophy();
  }

  updateTrophy(type?: any) {
    this.hideOthers = this.selectedType && this.selectedType.name === 'certificatePapyrus';
    // this.anotherType = this.selectedType && this.selectedType.name ==='LasVegas';
    // this.trophyComponent.switch(this.result);
    
  }

  ionViewWillLeave() {
    // this.trophyComponent.ionViewWillLeave();
  }
  ionViewWillEnter() {
    // this.trophyComponent.ngAfterViewInit();
  }

  async save() {
    console.log('save()')
    let loading = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loading.present();

    this.resultService.updateTrophy({
      hasDatum: !this.result.hasDatum,
      hasPlatz: !this.result.hasPlatz,
      hasStrecke: !this.result.hasStrecke,
      hasZeit: !this.result.hasZeit,
      resultId: this.result.id,
      trophyColor: parseInt(this.result.trophyColor),
      trophyMaterial: parseInt(this.result.trophyMaterial),
      trophyType: this.result.trophyType
    }).then((succ) => {
      if (succ) {
        this.resultBackup.hasDatum = this.result.hasDatum;
        this.resultBackup.hasPlatz = this.result.hasPlatz;
        this.resultBackup.hasStrecke = this.result.hasStrecke;
        this.resultBackup.hasZeit = this.result.hasZeit;
        this.resultBackup.trophyColor = this.result.trophyColor;
        this.resultBackup.trophyMaterial = this.result.trophyMaterial;
        this.resultBackup.trophyType = this.result.trophyType;
        this.navStateService.setState(this.resultBackup)
        this.navCtrl.back()
        // .then(() => loading.dismiss());
        loading.dismiss()
      } else {
        loading.dismiss();
      }
    });

  }
}
